// Forked from services/selectLists/caseTypes.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import { httpGet, httpPost, httpPatchMerge, httpDelete } from '../http'
import type { TEntityId } from '~/types/models'
import type { IServiceRequestType } from '~/types/serviceRequest/models'

const apiEntityPath = '/api/servicerequesttypes'

export async function getServiceRequestTypes() {
  const callingMn = getServiceRequestTypes.name
  const apiPath = `${apiEntityPath}`
  return httpGet<IServiceRequestType[]>({ callingMn, apiPath })
}

export async function createServiceRequestType(entity: IServiceRequestType) {
  const callingMn = createServiceRequestType.name
  const apiPath = apiEntityPath
  return httpPost<IServiceRequestType>({ callingMn, apiPath, entity })
}

export async function updateServiceRequestType(
  entityData: Partial<IServiceRequestType>,
  id: TEntityId
) {
  const callingMn = updateServiceRequestType.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialServiceRequestType = Partial<IServiceRequestType>
  return httpPatchMerge<TPartialServiceRequestType>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteServiceRequestType(
  entityData: IServiceRequestType
) {
  const callingMn = deleteServiceRequestType.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
